<template>
    <div id="app" :style="{ minHeight: H }">
        <keep-alive>
            <router-view />
        </keep-alive>
    </div>
</template>

<script>
import { isLogin, getQuery, setSessionKey } from '@/assets/js/util';

export default {
    data() {
        return {
            H: '100%',
        };
    },
    created() {
        const params = getQuery();
        if (process.env.VUE_APP_ENV === 'test' && !!params.userId && !!params.sessionKey) {
            setSessionKey({
                ...params,
            });
            this.$router.push({
                path: 'login',
                query: {
                    ...params,
                },
            });
            return
        }

        if ((params.code || !isLogin()) && window.location.pathname !== '/login') {
            this.$router.push({
                path: 'login',
                query: {
                    ...params,
                    redirectUrl:
                        decodeURIComponent(params.state || '')
                        || this.$route.query.redirectUrl
                        || params.redirectUrl
                        || `${window.location.pathname}${window.location.search}`,
                },
            });
            return
        }
        this.$store.dispatch('user/getUserInfo');
    },

    methods: {},
};
</script>

<style lang="less">
// @import '~vue2-animate/src/less/vue2-animate';
@import './assets/css/base.less';
//主题
@import './assets/css/color.less';
@import './assets/css/material-icons.css';
// @import "./assets/css/swiper.min.css";
/* IOS禁止微信调整字体大小 */
body,
html {
    -webkit-text-size-adjust: 100% !important;
    text-size-adjust: 100% !important;
    -moz-text-size-adjust: 100% !important;
    //   -webkit-font-smoothing: antialiased;
    //   -webkit-user-select: none;
    //   -webkit-touch-callout: none;
    font-family: Roboto, Lato, sans-serif, 'Avenir', Helvetica, Arial;

    width: 100%;
    height: 100%;
}

#app {
    //-webkit-overflow-scrolling: unset; //禁止ios橡皮筋遮挡tab
    -webkit-overflow-scrolling: touch;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
    max-width: 750px;
    min-width: 320px;
    height: auto;
    margin: 0 auto;

    .request-err {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 2rem 1rem;

        img {
            width: 4rem;
        }

        p {
            margin-top: 1rem;
            color: #999;
        }
    }
}

.noscroll {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
}

.mobile {
    .mu-input-help {
        display: none !important;
    }
}

//mescroll
.mescroll-empty .empty-btn {
    max-width: 50%;
    margin: 20px auto;
    padding: 10px;
    border-radius: 6px;
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}

//
.mu-raised-button {
    border-radius: 4px;
}

//一个loading
//<div class="lds-css ng-scope"><div style="width:100%;height:100%" class="lds-dual-ring"><div></div></div></div>
@keyframes lds-dual-ring {
    0% {
        -webkit-transform: rotate(0);
        transform: rotate(0);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@-webkit-keyframes lds-dual-ring {
    0% {
        -webkit-transform: rotate(0);
        transform: rotate(0);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.lds-dual-ring {
    position: relative;
}

.lds-dual-ring div {
    position: absolute;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    border: 10px solid #000;
    border-color: #ff3737 transparent #ff3737 transparent;
    -webkit-animation: lds-dual-ring 1s linear infinite;
    animation: lds-dual-ring 1s linear infinite;
}

.lds-dual-ring {
    width: 56px !important;
    height: 56px !important;
    -webkit-transform: translate(-28px, -28px) scale(0.28) translate(28px, 28px);
    transform: translate(-28px, -28px) scale(0.28) translate(28px, 28px);
}
</style>
